import { Controller } from "@hotwired/stimulus"

// Removes guest chip from DOM and tracks booking for removal on form submit
export default class extends Controller {
  remove(event) {
    event.preventDefault()
    const chip = event.target.closest("[data-lesson-guest-remover-target='chip']")
    if (!chip) return

    const bookingId = chip.dataset.bookingId
    if (!bookingId) return

    const form = this.element.closest("form")
    if (form) {
      const input = document.createElement("input")
      input.type = "hidden"
      input.name = "remove_booking_ids[]"
      input.value = bookingId
      form.appendChild(input)
    }

    chip.remove()
  }
}
